import { EditPeriodicCheckFeedbackOutDto, EditPeriodicCheckFeedbackInDto } from '../../../types/periodic-check.dto'

export const EDIT_PERIODIC_CHECK_FEEDBACK = 'EDIT_PERIODIC_CHECK_FEEDBACK'
export const EDIT_PERIODIC_CHECK_FEEDBACK_SUCCESS = 'EDIT_PERIODIC_CHECK_FEEDBACK_SUCCESS'
export const EDIT_PERIODIC_CHECK_FEEDBACK_ERROR = 'EDIT_PERIODIC_CHECK_FEEDBACK_ERROR'
export const RESET_EDIT_PERIODIC_CHECK_FEEDBACK = 'RESET_EDIT_PERIODIC_CHECK_FEEDBACK'

export interface EditPeriodicCheckFeedback {
  type: typeof EDIT_PERIODIC_CHECK_FEEDBACK
  payload: EditPeriodicCheckFeedbackOutDto
}

export interface EditPeriodicCheckFeedbackSuccess {
  type: typeof EDIT_PERIODIC_CHECK_FEEDBACK_SUCCESS
  payload: EditPeriodicCheckFeedbackInDto<any>
}

export interface EditPeriodicCheckFeedbackError {
  type: typeof EDIT_PERIODIC_CHECK_FEEDBACK_ERROR
  payload: string | boolean
}

export interface ResetEditPeriodicCheckFeedback {
  type: typeof RESET_EDIT_PERIODIC_CHECK_FEEDBACK
  payload: null
}
export interface State {
  data: EditPeriodicCheckFeedbackInDto<any> | null
  states: {
    loading: boolean
    success: boolean
    error: boolean | string
  }
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
}

export type Actions = EditPeriodicCheckFeedback | EditPeriodicCheckFeedbackSuccess | EditPeriodicCheckFeedbackError | ResetEditPeriodicCheckFeedback
